import { useEffect, useState } from "react";

interface UseTableFiltersOptions {
	filters: Array<{ id: string; value: any }>;
	isEnabled?: boolean;
	debounceMs?: number;
	onFilterChange?: (criteria: Record<string, object>) => void;
}

export const useTableFilters = ({
	filters,
	isEnabled = true,
	debounceMs = 500,
	onFilterChange,
}: UseTableFiltersOptions) => {
	const [filterCriteria, setFilterCriteria] = useState<
		Record<string, object>
	>({});

	useEffect(() => {
		if (!isEnabled || !filters) return;

		const handler = debounceMs
			? setTimeout(() => {
					updateFilterCriteria();
			  }, debounceMs)
			: null;

		if (!debounceMs) {
			updateFilterCriteria();
		}

		function updateFilterCriteria() {
			const newFilterCriteria: Record<string, object> = {};

			filters.forEach((filter) => {
				if (filter.value !== undefined && filter.value !== "") {
					newFilterCriteria[filter.id] = filter.value;
				}
			});

			setFilterCriteria(newFilterCriteria);

			if (onFilterChange) {
				onFilterChange(newFilterCriteria);
			}
		}

		return () => {
			if (handler) clearTimeout(handler);
		};
	}, [filters, isEnabled, debounceMs, onFilterChange]);

	return filterCriteria;
};
